var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:({
		color: '#0099FF'
	}),attrs:{"href":_vm.to,"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.handleClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }